import React, { useEffect, useState } from "react";
import ContactInfo from "./ContactInfo/ContactInfo";
import MediaLinks from "./MediaLinks/MediaLinks";
import ScheduleMessage from "./ScheduleMessage/ScheduleMessage";
import { postApiCaller } from "../../../Libs/apiCaller";

export default function ProfileView({
  activeSection,
  setActiveSection,
  setShowProfileView,
  chatConversationId,
  getSecretKey,
  activeChat,
  setActiveChat,
  settings,
  setSettings,
  secretKey,
  setAllMessages,
  setChatUsers,
}) {
  const [mediaList, setMediaList] = useState([]);
  const [linkList, setLinkList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [activeTab, setActiveTab] = useState("MEDIA");
  const [isMediaLoading, setIsMediaLoading] = useState(false);
  const [mediaCurrentPage, setMediaCurrentPage] = useState(1);
  const [linkCurrentPage, setLinkCurrentPage] = useState(1);
  const [linkTotalPage, setLinkTotalPage] = useState(1);
  const [documentsTotalPage, setDocumentsTotalPage] = useState(1);
  const [totalMedia, setTotalMedia] = useState(0);
  const [documentsCurrentPage, setDocumentsCurrentPage] = useState(1);
  const [mediaTotalPage, setMediaTotalPage] = useState(1);
  const [allUserTotalRecords, setAllUserTotalRecords] = useState(0);

  useEffect(() => {
    if (chatConversationId._id) {
      getMediaList();
    }
  }, [chatConversationId]);

  const getMediaList = async (type = "MEDIA", page = 1) => {
    page == 1 && setIsMediaLoading(true);
    const endPoint = `messages/media/get`;
    const response = await postApiCaller(endPoint, {
      conversationId: chatConversationId._id,
      mediaType: type,
      page,
    });

    if (response.status == 200) {
      setAllUserTotalRecords(response?.data?.allTotalRecords || 0);
      if (type === "MEDIA") {
        setMediaList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setMediaCurrentPage(response.data.pagination.currentPage);
        setMediaTotalPage(response.data.pagination.totalPages);
        setTotalMedia(response.data.pagination.totalRecords);
      } else if (type === "LINK") {
        setLinkList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setLinkCurrentPage(response.data.pagination.currentPage);
        setLinkTotalPage(response.data.pagination.totalPages);
      } else if (type === "DOCUMENT") {
        setDocumentsList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setDocumentsCurrentPage(response.data.pagination.currentPage);
        setDocumentsTotalPage(response.data.pagination.totalPages);
      }
    }
    setActiveTab((t) => {
      if (type == t) setIsMediaLoading(false);
      return t;
    });
  };

  return (
    <section className="w-full">
      {activeSection === "contact" && (
        <ContactInfo
          isMediaLoading={isMediaLoading}
          mediaList={mediaList}
          totalMedia={allUserTotalRecords}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
          activeChat={activeChat}
          setActiveChat={setActiveChat}
          settings={settings}
          setSettings={setSettings}
          chatConversationId={chatConversationId}
          setAllMessages={setAllMessages}
          setChatUsers={setChatUsers}
          getMediaList={getMediaList}
        />
      )}
      {activeSection === "media" && (
        <MediaLinks
          mediaList={mediaList}
          linkList={linkList}
          documentsList={documentsList}
          isMediaLoading={isMediaLoading}
          mediaCurrentPage={mediaCurrentPage}
          linkCurrentPage={linkCurrentPage}
          documentsCurrentPage={documentsCurrentPage}
          chatConversationId={chatConversationId}
          mediaTotalPage={mediaTotalPage}
          linkTotalPage={linkTotalPage}
          documentsTotalPage={documentsTotalPage}
          getMediaList={getMediaList}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          secretKey={secretKey}
        />
      )}
      {activeSection === "schedule" && (
        <ScheduleMessage
          activeChat={activeChat}
          getSecretKey={getSecretKey}
          chatConversationId={chatConversationId}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
        />
      )}
    </section>
  );
}
